// extracted by mini-css-extract-plugin
export default {"hiddenIcon":"BlobActionsMenu-module__hiddenIcon--EJrTU"};